import { useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, DialogActions, Divider, IconButton, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
  executingNumber: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ExecutingWarningDialog = ({ executingNumber, onCancel, onConfirm }: Props) => {
  const descriptionRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog
      open
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="executing-warning-dialog-title"
      aria-describedby="executing-warning-dialog-description"
    >
      <DialogTitle id="executing-warning-dialog-title" align="center">
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <WarningAmberIcon color="warning" />
          <span>Внимание</span>
        </Stack>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <div id="executing-warning-dialog-description" ref={descriptionRef} tabIndex={-1}>
          <Typography variant="h6" align="center" color="warning.main" gutterBottom>
            Клиентов в исполнении: <strong>{executingNumber}</strong>
          </Typography>
          <Divider sx={{ my: 1.5 }} />
          <Typography variant="body1" gutterBottom>
            Предыдущий сигнал ещё исполняется по части клиентов.
          </Typography>
          <Typography variant="body1" color="error">
            Если подать новый сигнал сейчас, то система отменит неисполненные поручения и начнёт синхронизацию с учётом
            нового сигнала.
          </Typography>
        </div>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button variant="outlined" color="inherit" fullWidth onClick={onCancel}>
          Отмена
        </Button>
        <Button variant="contained" color="warning" fullWidth onClick={onConfirm}>
          Продолжить
        </Button>
      </DialogActions>
    </Dialog>
  );
};
